import axios from 'axios'
import React, { useState, useRef, useMemo } from 'react'
import { connect } from 'react-redux'
import { NavLink, useNavigate } from 'react-router-dom'
import { ToastContainer, toast, Bounce } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { setToken, setUserInfo } from '../../../features/auth/authSlice'
import config from '../../../config'
import Countdown, { zeroPad } from 'react-countdown'

function Loginscreen({ setToken, setUserInfo }) {
  const inputRefs = useRef(
    Array(6)
      .fill(0)
      .map(() => React.createRef())
  )
  const [showFirstIcon, setShowFirstIcon] = useState(true)
  const [isLoginSection, setIsLoginSection] = useState(true)
  const [phoneNumber, setPhoneNumber] = useState('')
  const [values, setValues] = useState(Array(6).fill(''))
  const [timer, setTimer] = useState(Date.now() + 29999)
  const [quillvalue, setQuillValue] = useState('')
  const [disableOtp, setDisableOtp] = useState(true)

  const notify = () => {
    toast.error('Enter the Mobile Number First', {
      position: 'top-center' // You can override position per toast here
    })
  }
  const navigate = useNavigate()

  const toggleIcon = () => {
    setShowFirstIcon(prev => !prev)
  }

  console.log(isLoginSection)
  const toggleSection = () => {
    setIsLoginSection(!isLoginSection)
  }

  const handlePhoneNumberChange = e => {
    const value = e.target.value
    if (/^\d*$/.test(value)) {
      setPhoneNumber(value)
    }
  }

  const handleLogin = async (e, isResend = false) => {
    e.preventDefault()
    if (!phoneNumber || phoneNumber.trim() === '') {
      notify() // Show the toast message
      return // Exit the function to prevent the OTP request
    }
    try {
      const response = await axios.get(
        `${config.devapi}user/login1?phone=91${phoneNumber}`
        // {
        //   phone: `91${phoneNumber}`
        // }
      )
      console.log('OTP request successful:', response.data)
      // toggleSection()
      if (!isResend) {
        toggleSection() // Switch to OTP section
      }
      setTimer(Date.now() + 29999)
      setDisableOtp(true) // Switch to OTP section
    } catch (error) {
      console.error('OTP request failed:', error)
    }
  }

  const handleVerifyOTP = async e => {
    e.preventDefault()
    const otp = values.join('') // Assuming `values` contains the OTP digits
    if (otp.length !== 6) {
      alert('Please enter a valid 6-digit OTP.')
      return
    }
    try {
      const response = await axios.get(
        `${config.devapi}user/login1?phone=91${phoneNumber}&otp=${otp}`
        // {
        //   phone: `91${phoneNumber}`,
        //   otp
        // }
      )
      console.log(response.data)
      setToken(response.data.token)
      localStorage.setItem('userInfo', JSON.stringify(response.data))
      localStorage.setItem('authToken', response.data.token)
      navigate('/')
    } catch (error) {
      console.error(error)
      alert('An error occurred while verifying OTP.')
    }
  }

  const handleKeyUp = (index, event) => {
    const value = event.target.value
    const key = event.key

    // Make a copy of the current values array
    const newValues = [...values]

    if (key === 'Backspace') {
      // Clear current input and move to previous
      newValues[index] = ''
      setValues(newValues)

      if (index > 0 && inputRefs.current[index - 1]) {
        inputRefs.current[index - 1].current.focus()
      }
    } else {
      // Check if input is a single digit
      const code = parseInt(value)
      if (code >= 0 && code <= 9) {
        newValues[index] = code.toString()
        setValues(newValues)

        // Move to next input if available
        if (
          index < inputRefs.current.length - 1 &&
          inputRefs.current[index + 1]
        ) {
          inputRefs.current[index + 1].current.focus()
        }
      } else {
        // Clear invalid input
        newValues[index] = ''
        setValues(newValues)
      }
    }
  }

  const checkwhatsinside = e => {
    console.log(e)
    setQuillValue(e)
  }

  const Renderer = () => {
    setDisableOtp(false)
  }

  const countdownRenderer = ({ minutes, seconds }) => {
    return <span>{zeroPad(seconds)}</span>
  }

  const countDownTimer = useMemo(() => {
    console.log(timer)
    return (
      <Countdown
        key={timer}
        date={timer}
        onComplete={Renderer}
        renderer={countdownRenderer}
      />
    )
  }, [timer])

  return (
    <>
      <div className=" mt-1 d-flex flex-column align-items-center ">
        <h2>Authentication</h2>
        <h4>login to manage your Conversations</h4>
      </div>
      <div
        className="d-flex justify-content-start mt-3 flex-column"
        // style={{ minHeight: "30vh" }}
      >
        {/* <div className="mx-auto px-4 w-100" style={{ maxWidth: '18rem' }}> */}
        <div>
          {isLoginSection ? (
            <>
              <form onSubmit={handleLogin}>
                <section>
                  <div className="fileds d-flex flex-column gap-3">
                    <input
                      type="tel"
                      placeholder="Enter Mobile Number"
                      maxLength={10}
                      pattern="[0-9]*"
                      inputMode="numeric"
                      value={phoneNumber}
                      onChange={handlePhoneNumberChange}
                    />

                    <button className="pulls-right" type="submit ">
                      Log In
                    </button>
                  </div>
                </section>
              </form>
            </>
          ) : (
            <>
              <form onSubmit={handleVerifyOTP}>
                <section>
                  <span
                    className="fs-4"
                    onClick={() => {
                      setIsLoginSection(true) // Switch back to phone input section
                      setValues(Array(6).fill('')) // Reset all input values
                    }}
                    style={{ cursor: 'pointer', color: '#0f172a' }}
                  >
                    <ion-icon name="arrow-back-outline"></ion-icon>
                  </span>
                  <div className="title">OTP</div>
                  <div className="title">Verification Code</div>
                  <p>We have sent a verification code to your mobile number</p>
                  <div id="inputs" className="d-flex justify-content-center">
                    {[...Array(6)].map((_, index) => (
                      <input
                        key={index}
                        ref={inputRefs.current[index]}
                        className="varify"
                        type="text"
                        maxLength="1"
                        value={values[index]}
                        onChange={e => {
                          const newValues = [...values]
                          newValues[index] = e.target.value
                          setValues(newValues)
                        }}
                        onKeyUp={e => handleKeyUp(index, e)}
                      />
                    ))}
                  </div>
                  <button type="submit" className="pulls-right mt-2">
                    Submit
                  </button>
                  <div className="pw-reset ">
                    <button
                      className="hidden bg-transparent border-0"
                      disabled={disableOtp}
                      onClick={e => handleLogin(e, true)}
                    >
                      Resend OTP({countDownTimer})
                    </button>
                  </div>
                </section>
              </form>
            </>
          )}
        </div>
        {/* </div> */}
      </div>
    </>
  )
}

const mapStateToProps = ({ auth }) => {}

const mapDispatchToProps = {
  setToken,
  setUserInfo
}

export default connect(mapStateToProps, mapDispatchToProps)(Loginscreen)
